import { combineReducers, Dispatch, Reducer } from 'redux';

// Import your state types and reducers here.
import { CounterState } from './counter/types';
import counterReducer from './counter/reducer';

import { POTWState } from './potw/types';
import potwReducer from './potw/reducer';

export interface ConnectedReduxProps<S> {
    // Correct types for the `dispatch` prop passed by `react-redux`.
    // Additional type information is given through generics.
    dispatch: Dispatch<S>;
}

// The top-level state object
export interface ApplicationState {
    counter: CounterState;
    potw: POTWState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const reducers: Reducer<ApplicationState> = combineReducers<ApplicationState>({
    counter: counterReducer,
    potw: potwReducer
});



// WEBPACK FOOTER //
// ./store/index.ts